<style lang="less" scoped>
.chat {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  overflow: hidden;
  .group-title {
    padding: 10px 20px;
    font-size: 18px;
    font-weight: bold;
    height: 50px;
  }
  .messages {
    display: flex;
    flex-direction: column;
    padding: 10px 20px;
    height: 100%;
    margin-bottom: 100px;
    border: 1px solid #eee;
    overflow: auto;
    .message {
      margin: 10px;
      display: flex;
      max-width: 50%;
      .user-photo {
        width: 30px;
        height: 30px;
        border-radius: 5px;
        margin: 5px;
        flex-shrink: 0;
      }
      .message-body {
        display: flex;
        flex-direction: column;
        .user-name {
          color: #ccc;
        }
        .message-content {
          border: 1px solid #ddd;
          border-radius: 5px;
          padding: 3px 10px;
          font-size: 14px;
          flex: 1;
        }
        .message-time {
          color: #ddd;
          height: 1.5em;
        }
      }
    }
    .right {
      margin-left: auto;
      .user-name {
        text-align: right;
      }
      .message-time {
        text-align: right;
      }
    }
  }
  .sent {
    position: absolute;
    bottom: 0;
    width: 100%;
    padding: 10px 20px;
    height: 100px;
    display: flex;
    flex-direction: column;
    .msg-type-btn {
      font-size: 20px;
      margin: 5px;
      cursor: pointer;
    }
    .sent-content {
      display: flex;
      padding: 10px 0;
      .sengTxt {
        border: none;
        margin-right: 5px;
      }
    }
  }
}
.ant-dropdown-menu {
  display: flex !important;
  flex-wrap: wrap;
  width: 400px !important;
}
.loading {
  position: absolute;
  top: 40%;
  left: 50%;
}
.recoder {
  position: relative;
  box-shadow: 0 0 32px rgba(0, 0, 0, 0.15);
  width: 200px;
  height: 200px;
  background: #fff;
}
.sound-waves {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 70px;
}
.wavesItem {
  border: 1px solid #f2f2f2;
  width: 4px;
  background: green;
  margin: 2px;
}
.remainingRecTime {
  text-align: center;
  font-size: 20px;
}
.tipText {
  text-align: center;
  font-size: 14px;
  position: absolute;
  bottom: 70px;
  width: 100%;
}
.holdBtn {
  width: 50px;
  height: 50px;
  border-radius: 25px;
  text-align: center;
  padding: 0;
  position: absolute;
  bottom: 10px;
  left: calc(50% - 25px);
  background: green;
}
.send-btn{
  width: 80px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  color: #fff;
  background: #06BC8C;
  border-radius: 2px;
  position: absolute;
  right: 20px;
  top: 15px;
}
</style>
<template>
  <div class="chat">
    <div class="group-title">{{ $store.getters.currentClass.className }}</div>
    <div class="messages scroll" ref="message">
      <div
        v-for="(message, index) in groupMessages"
        :key="index"
        :class="{ message: true, right: message.bySelf }"
      >
        <img v-if="!message.bySelf" :src="getUserPhoto(message)" class="user-photo"/>
        <div class="message-body">
          <div class="user-name">{{ message.ext.nikeName }}</div>
          <div
            v-if="message.msgType === 'txt'"
            class="message-content"
            v-html="renderTxt(message.msg)"
          ></div>
          <div v-else-if="message.msgType === 'img'" class="message-content">
            <img
              :src="message.msg"
              @dblclick="preview(message.msg)"
              title="双击预览"
              style="max-width: 300px"
            />
          </div>
          <div v-else-if="message.msgType === 'audio'" class="message-content">
            <audio :src="message.msg" controls></audio>
          </div>
          <div v-else-if="message.msgType === 'video'" class="message-content">
            <video :src="message.msg" width="300px" controls></video>
          </div>
          <a-card v-else title="文件" style="width: 300px">
            <a slot="extra" :href="message.msg" :download="message.filename"
              >下载</a
            >
            <p>{{ message.filename || message.file.filename }}</p>
            <p>{{ getFileSize(message.ext.file_length) }}</p>
          </a-card>
          <div class="message-time">
            {{ format.format(Number(message.time)) }}
          </div>
        </div>
        <img v-if="message.bySelf"  :src="userPhoto&&userPhoto!=null?$userINfoBasePath +'/'+ userPhoto: mrImg" class="user-photo"/>
      </div>
    </div>
    <div class="sent">
      <div>
        <a-dropdown :trigger="['click']" placement="topLeft">
          <a-icon class="msg-type-btn" type="smile" />
          <a-menu slot="overlay">
            <a-menu-item
              v-for="(emoji, index) in emojiList"
              :key="index"
              @click="selectEmoji(index)"
              ><img :src="`faces/${emoji}`"
            /></a-menu-item>
          </a-menu>
        </a-dropdown>
        <a-icon @click="clickUpload()" class="msg-type-btn" type="picture" />
      </div>
      <div class="sent-content">
        <a-input
          :disabled="$store.state.classList.length === 0"
          v-model="msgText"
          equired
          placeholder="输入消息"
          class="sengTxt"
          @pressEnter="sendTextMsg"
          style="resize: none"
          ref="txtDom"
        />
        <input
          @change="fileChange"
          type="file"
          style="display: none"
          ref="uploadDom"
        />
        <a-button class="send-btn" @click="sendTextMsg" :disabled="msgText === ''" >发送</a-button
        >
      </div>
    </div>
    <a-modal v-model="previewVisible" title="" :footer="null" width="800px">
      <div style="text-align: center; padding: 20px">
        <a-spin class="loading" />
        <img
          :src="previewFile"
          style="position: relative; width: 100%; background-color: #fff"
        />
      </div>
    </a-modal>
  </div>
</template>

<script>
import WebIM from 'utils/WebIM'
import format from 'utils/format.js'
import emoji from 'utils/emoji.js'
import { getFileType, getFileSize } from 'utils/getFileInfo.js'
// import Recorder from 'js-audio-recorder'
export default {
  name: 'Chat',
  data () {
    return {
      format,
      getFileType,
      getFileSize,
      msgText: '',
      msgType: 'txt',
      emojiList: emoji.obj,
      previewVisible: false,
      previewFile: '',
      userPhoto: '',
      userId: '',
      userName: '',
      mrImg: require('../../../assets/imgs/teacher.png'),
    }
  },
  watch: {
    groupMessages (val) {
      this.scrollToBottom()
    }
  },
  mounted() {
    this.userName = this.$store.state.userInfo.name
    this.userId = this.$store.state.userInfo.id
    this.userPhoto = this.$store.state.userInfo.photo
    this.scrollToBottom()
  },
  computed: {
    groupMessages () {
      // 从消息记录中获取本群组的消息
      const messages = this.$store.state.msgList.filter(
        (msg) => msg?.to === this.$store.getters.currentClass.groupTag
      )
      return messages
    }
  },
  methods: {
    preview (src) {
      // 图片消息放大预览
      // window._czc.push(['_trackEvent', '班级群聊', '消息图片放大'])
      this.previewFile = src
      this.previewVisible = true
    },
    scrollToBottom () {
      // 聊天记录区域滚动条滚动至最底部
      const msgdiv = this.$refs.message
      setTimeout(() => {
        msgdiv.scrollTop = msgdiv.scrollHeight
      }, 1000)
    },
    getUserPhoto (message) {
      let reg = RegExp(/http/)
      if(message.ext?.avatar){
        if(reg.test(message.ext?.avatar)){
          return message.ext?.avatar
        }else{
          return this.$userINfoBasePath +'/'+ message.ext?.avatar
        }
      }else{
        return this.mrImg
      }
    },
    sentMessage (msg = '', file = null, msgType) {
      // 发送消息；msg消息文本；file消息文件；msgType消息类型（txt，img，file，audio，video）
      // if(this.shareData.imGroupList.length===0) return
      const vm = this
      vm.msgType = msgType
      const id = WebIM.conn.getUniqueId()
      const time = +new Date()
      // eslint-disable-next-line new-cap
      const msgObj = new WebIM.message(msgType, id)
      let option = {
        to: this.$store.getters.currentClass.groupTag,
        chatType: 'groupChat',
        ext: {
          nikeName: JSON.parse(localStorage.getItem('user_info')).name,
          avatar: JSON.parse(localStorage.getItem('user_info')).photo
        }
      }
      if (msg) option = Object.assign(option, { msg: this.msgText })
      if (file) {
        option = Object.assign(option, {
          file: file,
          ext: { ...option.ext, file_length: file.data.size }
        })
      }
      msgObj.set({
        ...option,
        onFileUploadError: function (error) {
          vm.$message.error('图片上传失败', error)
        },
        onFileUploadComplete: function (data) {
          const url = data.uri + '/' + data.entities[0].uuid
          // console.log('url', url)
          option.msg = url
          if (vm.msgType !== 'txt') {
            const message = {
              ...option,
              from: vm.userId,
              fromUserName: vm.userName,
              fromUserPhoto: vm.userPhoto,
              msgType: vm.msgType,
              bySelf: true,
              time: time,
              id: id,
              status: 'sent'
            }
            vm.$store.commit('setMsgList', message)
          }
        },
        success: function () {
          // 更新消息列表
          // console.log('vm.msgType', vm.msgType === 'txt')
          // window._czc.push(['_trackEvent', '班级群聊', '发送消息', vm.msgType])
          if (vm.msgType === 'txt') {
            const message = {
              ...option,
              from: vm.userId,
              fromUserName: vm.userName,
              fromUserPhoto: vm.userPhoto,
              msgType: vm.msgType,
              bySelf: true,
              time: time,
              id: id,
              status: 'sent'
            }
            // console.log('message', message.time.toString().length, message)
            vm.$store.commit('setMsgList', message)
            vm.msgText = ''
          }
          vm.scrollToBottom()
        },
        fail: function (e) {
          vm.$message.error('发送失败！' + e)
        }
      })
      WebIM.conn.send(msgObj.body)
    },
    sendTextMsg () {
      // 发送文本消息
      if (this.msgText === '' || this.msgText === '\n') {
        this.msgText = ''
        this.$message.info('不能发送空消息！')
        return false
      }
      this.sentMessage(this.msgText, null, 'txt')
    },
    selectEmoji (e) {
      // 选择并发送表情消息
      this.msgText = e
      this.sendTextMsg()
    },
    renderTxt (txt = '') {
      // 处理并显示表情符号
      const rnTxt = []
      let match = null
      const regex = /(\[.*?\])/g
      let start = 0
      let index = 0
      while ((match = regex.exec(txt))) {
        index = match.index
        if (index > start) {
          rnTxt.push(txt.substring(start, index))
        }
        if (match[1] in emoji.obj) {
          const v = emoji.obj[match[1]]
          rnTxt.push(this.customEmoji(v))
        } else {
          rnTxt.push(match[1])
        }
        start = index + match[1].length
      }
      rnTxt.push(txt.substring(start, txt.length))
      return rnTxt.toString().replace(/,/g, '')
    },
    customEmoji (value) {
      return `<img src="faces/${value}" style="width:30px"/>`
    },
    clickUpload () {
      const upload = this.$refs.uploadDom
      upload && upload.click()
    },
    fileChange (e) {
      const target = e.target
      const file = WebIM.utils.getFileUrl(target)
      if (!file || file.data.size === 0) {
        this.$message.info('不能上传空文件！')
        return false
      }
      if (file.data.size / 1024 / 1024 > 10) {
        this.$message.info('文件大小不能超过10M，请压缩后上传！')
        return false
      }
      const type = getFileType(file.filetype)
      if (type === 'audio' || type === 'video') file.duration = 60
      this.sentMessage('', file, type)
    }
  }
}
</script>
